{
  "unknown": "Неизвестный кандидат",
  "phonePlaceholder": "+",
  "selectedCandidates": {
    "meta": {
      "title": "Выбранные кандидаты",
      "description": "Подбор выбранных кандидатов"
    },
    "title": "Выбранные кандидаты",
    "breadcrumbTail": "Выбранные кандидаты",
    "allWithCount": "Все ({{count}})",
    "emptyListTitle": "Список кандидатов пуст",
    "emptyListHint": "Кандидатов для подбора не найдено.",
    "recommendedTitle": "Рекомендованные кандидаты",
    "recommendedCount_one": "кандидат",
    "recommendedCount_few": "кандидата",
    "recommendedCount_many": "кандидатов",
    "recommendedCount_other": "кандидата",
    "pick": "Подобрать",
    "pickDescription": "Нажмите кнопку «Подобрать», чтобы выбрать новых кандидатов",
    "loadingRecommended": "Загрузка рекомендованных кандидатов",
    "loadingSelected": "Загрузка выбранных кандидатов",
    "close": "Закрыть",
    "detailPrev": "Предыдущий",
    "detailNext": "Следующий",
    "table": {
      "id": "ID",
      "fullName": "Имя Фамилия"
    },
    "drawerTitle": "Подбор кандидатов",
    "vacancy": "Вакансия:",
    "vacantPlaces": "Вакантных мест:",
    "noRelevantTitle": "Релевантных кандидатов не найдено",
    "noRelevantHint": "Для подбора новых кандидатов нажмите кнопку «Подобрать».",
    "noRelevantHintTryLater": "На данный момент релевантных кандидатов не найдено. Попробуйте выполнить подбор позже",
    "candidatePosition": "Кандидат: ",
    "positionFraction": "{{current}} / {{total}}",
    "age": "Возраст:",
    "matchAssessment": "Оценка соответствия кандидата",
    "matchStatusFits": "Подходит",
    "matchStatusMostlyFits": "Хороший потенциал",
    "matchStatusPartial": "Слабый потенциал",
    "matchStatusNotFits": "Не подходит",
    "matchReasonShow": "Показать",
    "matchReasonHide": "Скрыть",
    "readyToWork": "Готов выйти на работу",
    "summary": "Опыт работы и навыки",
    "incomeLevel": "Уровень дохода",
    "phone": "Номер телефона",
    "phoneTooltip": "Номер телефона станет доступен после выбора кандидата",
    "reject": "Отклонить",
    "select": "Выбрать",
    "decisionPending": "Решение не принято",
    "decisionSelected": "Кандидат выбран",
    "decisionRejected": "Кандидат отклонён",
    "openCandidatesList": "Показать список кандидатов",
    "backToPick": "Вернуться",
    "candidatesCount": "Кандидатов: {{count}}",
    "skillsFitLine1": "Подходит",
    "skillsFitLine2": "по навыкам на:",
    "rejectModal": {
      "title": "Отклонение кандидатуры",
      "confirmBeforeName": "Вы уверены, что хотите отклонить кандидатуру ",
      "confirmAfterName": "? Кандидат больше не будет предложен для данной вакансии",
      "noRejectionReasons": "Нет доступных причин отклонения. Обратитесь к администратору или попробуйте позже.",
      "reasonLabel": "Причина отклонения",
      "customDetailLabel": "Пояснение к причине отклонения",
      "customDetailDescription": "Опишите причину отклонения. Не более {{max}} символов",
      "commentPlaceholder": "Комментарий",
      "back": "Назад",
      "confirmReject": "Отклонить",
      "validationCustomRequired": "Укажите пояснение к причине отклонения",
      "maxLength": "Не более {{max}} символов",
      "customReasonPrefix": "Свой вариант: ",
      "reasons": {
        "requirements": "Кандидат не соответствует требованиям",
        "experience": "Недостаточный опыт",
        "custom": "Свой вариант"
      }
    }
  },
  "status": {
    "proposed": "Предложен",
    "accepted": "Принят",
    "rejected": "Отклонен"
  },
  "match": {
    "skills": "Подходит по навыкам на {{percent}}%"
  }
}
